import { Container, Box, Button, Grid } from "@mui/material";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { SearchComponent } from "../SearchComponent";
import CustomButton from "../customComponent/CustomButton";
import { useRecoilState, useSetRecoilState } from "recoil";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import InspRuleTable from "./InspRuleTable.js";
import { InspRuleModal } from "./InspRuleModal.js";

export default function InspRuleMain() {
  const navigate = useNavigate();
  const [page, setPage] = useState<number>(1);
  const [keyword, setKeyword] = useState<string | null>(null);
  const [openModal, setOpenModal] = useState(false);
  const [count, setCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [receivedData, setReceivedData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedModelInfo, setSelectedModelInfo] = useState(null);

  return (
    <>
      <div className="p-8">
        <div className="flex items-center justify-between">
          <h1 className="text-3xl font-bold text-gray-900">검사 규칙</h1>
        </div>
      </div>
      <Container
        sx={{ display: "flex", flexDirection: "column" }}
        maxWidth={false}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            height: "42px",
          }}
        >
          <CustomButton
            id="new-train-btn"
            text={t("CreateInspRule")}
            variant="outlined"
            onClick={() => {
              navigate("/insp-rule/create");
            }}
            // onClick={handleOpenModal}
          />
          <SearchComponent
            menu="insp_rule"
            setPage={setPage}
            keyword={keyword}
            setKeyword={setKeyword}
          />
        </Box>
        <InspRuleTable
          setCount={setCount}
          setOpenModal={setOpenModal}
          receivedData={receivedData}
          setReceivedData={setReceivedData}
          total={count}
          page={currentPage}
          setPage={setCurrentPage}
          setSelectedModelInfo={setSelectedModelInfo}
          keyword={keyword}
        />
        {/* <TrainTable
          page={page}
          setPage={setPage}
          keyword={keyword}
          aiKeyAndValues={aiKeyAndValues}
          setIsRemoveModule={setIsRemoveModule}
        />
        */}
        {openModal && (
          <InspRuleModal
            ruleData={selectedModelInfo}
            openModal={openModal}
            setOpenModal={setOpenModal}
          />
        )}
      </Container>
    </>
  );
}
